module.exports = __webpack_public_path__ + "static/media/missing-model@2x.4bd33e6c.png";